
<template>
  <div>
    <h3>{{name}}'s Bibliothek</h3>
    <div class="container-fluid">
      <div class="row">
        <div v-for="(result, index) in assets" :key="result.$id" class="col-sm-12">
          <div class="card m-3 bg-light">
            <div class="card-header text-center">
                <router-link v-bind:to="/schule/ + $route.params.schoolId + /bibliothek/ + result.$id" class="nav-link">{{ result.name }}</router-link>
            </div>
            <div class="card-body" style="height:100%">
              <network
                class="network visContainer"
                :ref="`${result.$id}`"
                @select-node="selectNode(result.$id, index)"
                :nodes="result.network.nodes"
                :edges="result.network.edges"
                :options="result.network.options"
              />
            </div>           
          </div>
        </div>
         <section class="detailContainer" v-if="currentSelectedNode">
              <h2>{{currentSelectedNode.label}}</h2>

              <star-rating
                v-model="currentSelectedNode.rating"
                v-bind:star-size="20"
                active-color="#0065f9"
                v-bind:border-width="2"
                v-bind:glow="2"
                read-only
              ></star-rating>

              <hr class="white" />
              <p>{{currentSelectedNode.abstract}}</p>

              <section v-if="currentSelectedNode.materials" class="materials">
                <h4>Materialien</h4>
                <ul>
                  <li v-for="item in currentSelectedNode.materials" :key="item.id">
                    <a v-bind:href="item.url">{{ item.label }}</a>
                  </li>
                </ul>
              </section>
            </section>
      </div>
    </div>
    <button @click="duplicate()">duplicate</button>
  </div>
</template>
<script>
import { fetchSchool, fetchAssets,duplicateGraph } from "../firebase/firebase";
import { DataSet } from "vue2vis";
export default {
  name: "library",
  methods: {
    duplicate(){
      duplicateGraph()
    },
    selectNode(ref, index) {
      let nodeId = this.$refs[ref][0].getSelection().nodes[0];
      this.currentSelectedNode =
        nodeId != null ? this.assets[index].network.nodes.get(nodeId) : null;
    }
  },
  data() {
    return {
      unsubscribe: null,
      name: "",
      assets: [],
      currentSelectedNode: null
    };
  },
  async created() {
    this.name = (
      await fetchSchool(this.$route.params.schoolId).get()
    ).data().name;

    this.unsubscribe = fetchAssets(this.$route.params.schoolId).onSnapshot(
      querySnapshot => {
        this.assets = querySnapshot.docs.map(doc => {
          const $data = doc.data();
          console.log(JSON.stringify($data));

          return {
            $id: doc.id,
            name: $data.name,
            network: {
              nodes: new DataSet($data.nodes),
              edges: new DataSet($data.edges),
              options: {
                groups: {
                  switch: {
                    shape: "box",
                    color: "#24d453" // green
                  }
                }
              }
            }
          };
        });
      }
    );
  },
  destroyed() {
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }
};
</script>
<style scoped>

.main {
  height: 100%;
  display: flex;
}

.visContainer {
  height: 100%;
  width: 100%;
}

.detailContainer {
  width: 35%;
  height: 100%;
  position: absolute;
  right: 0;
  opacity: 0.85;
  background: #000;
  padding: 10px;
  color: #fff;
}

.detailContents {
  color: #fff;
  margin: 10px;
}

.white {
  display: block; height: 1px;
    border: 0; border-top: 1px solid #ccc;
    margin: 1em 0; padding: 0; 
}

.materials {
  font-size: smaller
}

.rating {

}

</style>